export default {
  documentContent: {},
  allClass: [],
  individualClass: [],
  blacklistedField: [],
};
